import * as React from 'react'
import * as classnames from 'classnames'
import { Link } from 'react-router-dom'

import * as styles from './buttons.css'
import { observable } from 'mobx'

interface ButtonProp extends React.HTMLAttributes<HTMLAnchorElement> {
  to?: string
  onClick?: (e: any) => void
  language?: string
  buttonStyle?: string

  children?: React.ReactNode

  isExternal?: boolean
}

class Button extends React.Component<ButtonProp> {
  render () {

    const s = classnames(this.props.buttonStyle, this.props.className, styles.button)
    if (this.props.to) {
      if (this.props.isExternal) {
        return <a href={this.props.to} rel='noopener' target='_blank' className={s}> {this.props.children} </a>
      }
      return <Link to={this.props.to} className={s}> {this.props.children} </Link>
    } else {
      return <div className={s} onClick={this.props.onClick} > {this.props.children} </div>

    }
  }
}

export class LesenButton extends React.Component<ButtonProp> {
  @observable hoverButton = false

  render () {

    let text = this.props.language && this.props.language === 'en' ? 'Read' : 'Lesen'

    return (
      <Button {...this.props} buttonStyle={classnames(styles.buttonLesen, this.hoverButton ? styles.buttonLesenScaleup : styles.buttonLesenScaledown)}>
        {this.props.children}
        <div className={styles.lesenText} onMouseEnter={() => this.hoverButton = true} onMouseLeave={() => this.hoverButton = false}>{text}</div>
      </Button>
    )
  }
}

export class StartButton extends React.Component<ButtonProp> {
  @observable hoverButton = false
  render () {
    return (
      <Button {...this.props} buttonStyle={classnames(styles.buttonLesen, this.hoverButton ? styles.buttonLesenScaleup : styles.buttonLesenScaledown)}>
        {this.props.children}
        <div className={styles.lesenText} onMouseEnter={() => this.hoverButton = true} onMouseLeave={() => this.hoverButton = false}>Start</div>
      </Button>
    )
  }
}

export class MuteButton extends React.Component<ButtonProp> {

  render () {
    return (
      <Button {...this.props} buttonStyle={styles.buttonMute}></Button>
    )
  }
}

export class UnmuteButton extends React.Component<ButtonProp> {

  render () {
    return (
      <Button {...this.props} buttonStyle={styles.buttonUnmute}></Button>
    )
  }
}

export class PlayButton extends React.Component<ButtonProp> {

  render () {
    return (
      <Button {...this.props} buttonStyle={styles.buttonPlay}></Button>
    )
  }
}

export class MenuButton extends React.Component<ButtonProp> {

  render () {
    return (
      <Button {...this.props} buttonStyle={styles.buttonMenu}></Button>
    )
  }
}

export class MenuCloseButton extends React.Component<ButtonProp> {

  render () {
    return (
      <Button {...this.props} buttonStyle={styles.buttonMenuClose}></Button>
    )
  }
}

export class CloseButtonBlack extends React.Component<ButtonProp> {

  render () {
    return (
      <Button {...this.props} buttonStyle={styles.closeButtonBlack}></Button>
    )
  }
}

export class CloseButtonYellow extends React.Component<ButtonProp> {

  render () {
    return (
      <Button {...this.props} buttonStyle={styles.closeButtonYellow}></Button>
    )
  }
}

export class CloseButtonMobile extends React.Component<ButtonProp> {

  render () {
    return (
      <Button {...this.props} buttonStyle={styles.closeButtonMobile}></Button>
    )
  }
}

export class TickButton extends React.Component<ButtonProp> {

  render () {
    return (
      <Button {...this.props} buttonStyle={styles.buttonTick}></Button>
    )
  }
}

export class BackButton extends React.Component<ButtonProp> {

  render () {
    return (
      <Button {...this.props} buttonStyle={styles.buttonBack}></Button>
    )
  }
}

export class IntroAnsehenButton extends React.Component<ButtonProp> {

  render () {

    let text = this.props.language && this.props.language === 'en' ? 'Watch intro' : 'Intro ansehen'

    return (
      <Button {...this.props} buttonStyle={styles.buttonIntroAnsehen}>
        <div className={styles.introAnsehenImg} />{text}</Button>
    )
  }
}

export class ImgSourceOpenButton extends React.Component<ButtonProp> {

  render () {
    return (
      <Button {...this.props} buttonStyle={styles.buttonImgSourceOpen}></Button>
    )
  }
}

export class ImgSourceCloseButton extends React.Component<ButtonProp> {

  render () {
    return (
      <Button {...this.props} buttonStyle={styles.buttonImgSourceClose}></Button>
    )
  }
}

export class ExternalLinkButton extends React.Component<ButtonProp> {

  render () {
    return (
      <Button {...this.props} buttonStyle={styles.buttonExternalLink}>
        <div className={styles.externalLinkImg}/>{this.props.children}</Button>
    )
  }
}

export class SourcesButton extends React.Component<ButtonProp> {

  render () {
    return (
      <Button {...this.props} buttonStyle={styles.buttonSources}>
        <div className={styles.sourcesImg}/>{this.props.children}</Button>
    )
  }
}

export class ImprintButton extends React.Component<ButtonProp> {

  render () {
    return (
      <Button {...this.props} buttonStyle={styles.buttonImprint}>
        <div className={styles.imprintImg}/>{this.props.children}</Button>
    )
  }
}

export class ShowSectionsButton extends React.Component<ButtonProp> {

  render () {
    return (
      <Button {...this.props} buttonStyle={styles.buttonShowSections}></Button>
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/common/elements/buttons.tsx